import { ChainId, tokens as venusTokens } from '@endure/chains';

export const tokens = venusTokens[ChainId.BSC_TESTNET];
